module.exports = __webpack_public_path__ + "img/click2.2727084d.png";